import React, { useState, useEffect } from "react";
import { Automations } from "./Automations";
import { Scenarios } from "./Scenarios";
import { useTranslation } from "react-i18next";
const AutoOrSen = () => {
  const { t } = useTranslation();
  const [x, setX] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const showSenarios = () => {
    setX(false);
    setViewIndex(0);
  };
  const showAutomation = () => {
    setX(true);
    setViewIndex(2);
  };
  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 992) {
      setIsPhone(true);
    }
  }, []);
  return (
    <>
      {}

      {!x ? <Scenarios /> : <Automations />}
    </>
  );
};
export { AutoOrSen };
